import LazyLoad from "vanilla-lazyload";

new LazyLoad({
    elements_selector: ".lazy-loading",
    load_delay: 300,
});
